import * as moment from 'moment';

export function formatDate(date, lang) {
    let dateFormated = moment(date);
    dateFormated.locale(lang)
    return dateFormated.format('LL');
}

export function formatDateOfBirth(date, lang) {
    let dateFormated = moment(date, moment.ISO_8601);
    dateFormated.locale(lang);
    return dateFormated.format("DD/MM/YYYY");
}

export function formatDateOfBirth2(date, lang) {
    let dateFormated = moment(date, moment.ISO_8601);
    dateFormated.locale(lang);
    if (lang === "fr") {
        return dateFormated.format("D MMMM, YYYY");
    }
    return dateFormated.format("MMMM D, YYYY");
}

export function getToday(lang) {
    let today = moment()
    today.locale(lang)
    if (lang === "fr") {
        return today.format("D MMMM, YYYY");
    }
    return today.format("MMMM D, YYYY")
}

export function isInIFrame(){
    return window !== window.parent
}